import { type ReactNode, useState } from 'react';

import type { DateInput } from '@repo/common';
import { startOfDay, startOfMonth } from '@repo/common';

import { usePeriodCalendar } from '../../../hooks/use-calendar';
import { MonthlyCalendar } from '../../MonthlyCalendar/MonthlyCalendar';
import { YearlyCalendar } from '../../YearlyCalendar/YearlyCalendar';

interface CalendarDateSelectorContentProps {
  onDateSelect?: (date: Date) => void;
  allowPastDates?: boolean;
  renderDayMarker?: (day: Date) => ReactNode;
}

export function CalendarDateSelectorContent({
  onDateSelect,
  allowPastDates,
  renderDayMarker,
}: CalendarDateSelectorContentProps) {
  const [isYearlyCalendarOpen, setIsYearlyCalendarOpen] = useState(false);
  const { currentPeriod, setCurrentPeriod } = usePeriodCalendar();

  const toggleCalendarView = () => {
    setIsYearlyCalendarOpen(prev => !prev);
  };

  const handleMonthSelect = (month: DateInput) => {
    const startOfMonthDate = startOfMonth(month);
    setCurrentPeriod(startOfMonthDate);
    toggleCalendarView();
  };

  return isYearlyCalendarOpen ? (
    <YearlyCalendar onMonthSelect={handleMonthSelect} initialDate={currentPeriod} />
  ) : (
    <MonthlyCalendar
      onHeaderClick={toggleCalendarView}
      allowPastDates={allowPastDates}
      renderDayMarker={renderDayMarker}
      onDateSelect={date => {
        const selectedDay = startOfDay(date);
        setCurrentPeriod(selectedDay); // Handle date selection in the monthly view.
        onDateSelect?.(selectedDay);
      }}
    />
  );
}
